// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationMessage/styles.scss
// module id = 1009
// module chunks = 0